import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';

/**
 * Confirmação genérica Sim/Não (MUI v5), sem estado/fetch próprio — a lógica
 * de mutação e o guard de sessão (`useSessaoDialogMutacao`, quando o fluxo é
 * uma mutação real) pertencem a quem instancia o dialog, nunca a este
 * componente (AW2-1133 Etapa 7, 1ª aplicação: "Mãozinha cortada" para
 * Simulação/Proposta — `cancelarSimulacao`/`cancelarProposta`, ver
 * `TableAcordos.jsx`). `confirmando` desabilita os 2 botões enquanto uma
 * chamada está em voo, sem fechar o dialog sozinho — quem chama decide
 * quando fechar.
 */
export default function ConfirmDialog({
  open, title, text, onConfirmar, onFechar, confirmando,
}) {
  return (
    <Dialog open={open} onClose={confirmando ? undefined : onFechar} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar} disabled={confirmando}>Não</Button>
        <Button onClick={onConfirmar} variant="contained" disabled={confirmando}>Sim</Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  onConfirmar: PropTypes.func.isRequired,
  onFechar: PropTypes.func.isRequired,
  confirmando: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
  open: false,
  title: '',
  text: '',
  confirmando: false,
};
